export default __webpack_public_path__ + "static/media/Picture6.a0c44dae.png";